import 'mroshopcommon/src/utils/hina';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia, PiniaVuePlugin } from 'pinia';
import 'uno.css';
import 'animate.css';
import './assets/style/main.scss';
import './permission';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/element-variables.scss';
import './assets/iconFont/iconfont.css';
import directive from './directive'; // directive
import SlideVerify from 'vue-monoplasty-slide-verify';
// 打印
import Print from 'vue-print-nb';
// Global instruction

Vue.use(Print);

Vue.use(SlideVerify);
Vue.use(PiniaVuePlugin);
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
export const pinia = createPinia();
Vue.use(ElementUI);
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
Vue.use(directive);
VueAMap.initAMapApiLoader({
  key: '7b3d462b1f4a213cf8f2a272e8a91a42',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.MouseTool',
    'AMap.PolyEditor',
    'AMap.LabelMarker',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Heatmap',
    'AMap.Geocoder',
    'AMap.CitySearch',
  ],
  v: '1.4.4',
});

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, { easing: 'ease-in-out' });
import { createHead } from '@unhead/vue';
import { UnheadPlugin } from '@unhead/vue/vue2';
import { InferSeoMetaPlugin } from '@unhead/addons';
const head = createHead();
head.use(InferSeoMetaPlugin());
Vue.use(UnheadPlugin);

new Vue({
  render: h => h(App),
  router,
  pinia,
  unhead: head,
}).$mount('#app');
